// extracted by mini-css-extract-plugin
module.exports = {"card-container":"TopCategoryCard_card-container__3EmON","chevron":"TopCategoryCard_chevron__1IFp0","icon":"TopCategoryCard_icon__2DEt1","title":"TopCategoryCard_title__h7SS9"};